import { DATA_STORE_KEYS, DataStore } from '@providers/dataStore';
import { useEffect } from 'react';

const HardReset = () => {
    useEffect(() => {
        [
            DATA_STORE_KEYS.USER,
            DATA_STORE_KEYS.USER_EMPLOYEE,
            DATA_STORE_KEYS.IS_LOGGEDIN,
            DATA_STORE_KEYS.USER_CURRENT_ROLE,
            DATA_STORE_KEYS.USER_DATA,
        ].forEach(key => DataStore.removeItem(key));
        window.location.href = '/';
    }, []);
    return <></>;
};

export default HardReset;
